import { render, staticRenderFns } from "./GoldPrice.vue?vue&type=template&id=41d1d3e1&"
import script from "./GoldPrice.vue?vue&type=script&lang=js&"
export * from "./GoldPrice.vue?vue&type=script&lang=js&"
import style0 from "./GoldPrice.vue?vue&type=style&index=0&id=41d1d3e1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports